import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { trips } from '../api';
import TripDetailScreen from '../screens/TripDetailScreen';

// Public share link: /trip/:shareSlug. Resolved by the unguessable slug only —
// the numeric trip id never appears in a public URL or payload.
export default function TripDetailRoute() {
  const { shareSlug } = useParams();
  const [searchParams] = useSearchParams();
  const [trip, setTrip] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showBookingBanner, setShowBookingBanner] = useState(false);
  const [bookingUrl, setBookingUrl] = useState('');

  useEffect(() => {
    if (!shareSlug) return;
    trips.getBySlug(shareSlug)
      .then(setTrip)
      .catch((err) => console.error('Failed to load trip:', err))
      .finally(() => setLoading(false));
  }, [shareSlug]);

  useEffect(() => {
    const bookParam = searchParams.get('book');
    if (bookParam === 'true' && trip?.destination) {
      const affiliateId = process.env.REACT_APP_BOOKING_AFFILIATE_ID;
      if (affiliateId) {
        const dest = encodeURIComponent(trip.destination);
        const checkin = trip.startDate || '';
        const checkout = trip.endDate || '';
        const creatorId = searchParams.get('creatorId');
        const label = creatorId ? `&label=${creatorId}` : '';
        setBookingUrl(`https://www.booking.com/searchresults.html?ss=${dest}&checkin=${checkin}&checkout=${checkout}&aid=${affiliateId}${label}`);
        setShowBookingBanner(true);
      }
    }
  }, [searchParams, trip]);

  const handleBookingClick = () => {
    if (bookingUrl) {
      window.open(bookingUrl, '_blank');
      setShowBookingBanner(false);
    }
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading trip...</div>;
  if (!trip) return <div style={{ padding: 40, textAlign: 'center' }}>Trip not found</div>;

  return (
    <>
      {showBookingBanner && (
        <div style={{ background: '#1a6b4a', color: 'white', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100 }}>
          <span>Ready to book hotels for {trip.destination}?</span>
          <button onClick={handleBookingClick} style={{ background: 'white', color: '#1a6b4a', padding: '8px 20px', borderRadius: 8, fontWeight: 'bold', border: 'none', cursor: 'pointer' }}>
            Find Hotels
          </button>
        </div>
      )}
      <TripDetailScreen trip={trip} goScreen={() => window.history.back()} showToast={() => {}} user={null} />
    </>
  );
}
